// @ts-nocheck
// Combined analytics scripts
window.addEventListener('load', function () {
  // Google Tag Manager
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-N2QW7W6');

  // Bing UET
  (function (w, d, t, r, u) {
    var f, n, i;
    w[u] = w[u] || [];
    f = function () {
      var o = { ti: '148024933', enableAutoSpaTracking: true };
      o.q = w[u];
      w[u] = new UET(o);
      w[u].push('pageLoad');
    };
    n = d.createElement(t);
    n.src = r;
    n.async = true;
    n.onload = n.onreadystatechange = function () {
      var s = this.readyState;
      if (!s || s === 'loaded' || s === 'complete') {
        f();
        n.onload = n.onreadystatechange = null;
      }
    };
    i = d.getElementsByTagName(t)[0];
    i.parentNode.insertBefore(n, i);
  })(window, document, 'script', '//bat.bing.com/bat.js', 'uetq');
});
